module.exports = __webpack_public_path__ + "img/eth-dark-logo.e8079f93.svg";